export const KEY_CODES = {
    ENTER: 'Enter',
    SPACE: 'Space',
    DOWN_ARROW: 'ArrowDown',
    ESC: 'Escape',
    UP_ARROW: "ArrowUp"
}